//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"AddRemoteFindingAfterSnap",1,0],[0,"AutoDimensionsToArcCenter",1,0],[0,"AutoReverse",1,0],[0,"BackgroundOption",1,1],[0,"ChainCurves",1,0],[0,"ChangeViewOrientation",1,0],[0,"ConstraintSymbolSize",1,0],[0,"ContinuousAutoDimensioning",1,0],[0,"CreateDimensionForTypedValues",1,0],[0,"CreateInferredConstraints",1,0],[0,"CreatePersistentRelations",1,0],[0,"CreateReferenceGeometry",1,0],[0,"DefaultArcNamePrefix",1,0],[0,"DefaultConicNamePrefix",1,0],[0,"DefaultLineNamePrefix",1,0],[0,"DefaultSketchNamePrefix",1,0],[0,"DefaultSplineNamePrefix",1,0],[0,"DefaultVertexNamePrefix",1,0],[0,"DelayEvaluation",1,0],[0,"DimensionLabel",1,0],[0,"DisplayAutoDimensions",1,0],[0,"DisplayConstraintSymbols",1,0],[0,"DisplayDOFArrows",1,0],[0,"DisplayObjectColor",1,0],[0,"DisplayObjectName",1,0],[0,"DisplayParenthesesOnReferenceDimensions",1,0],[0,"DisplayReferenceGeometry",1,0],[0,"DisplaySectionMappingWarning",1,0],[0,"DisplayShadedRegions",1,0],[0,"DisplayVertices",1,0],[0,"DynamicConstraintDisplay",1,0],[0,"EditDimensionOnCreation",1,0],[0,"FindMovableObjects",1,0],[0,"FixedTextSize",1,0],[0,"GroupConstraintOption",1,0],[0,"LayoutDimensionTextMode",1,0],[0,"LineOutputOption",1,0],[0,"MaintainBlankStatus",1,0],[0,"MaintainLayerStatus",1,0],[0,"OriginOption",1,1],[0,"OverrideConstraints",1,0],[0,"RelaxDimensions",1,0],[0,"RetainDimensions",1,1],[0,"RigidSetConstraintOption",1,1],[0,"ScaleOnFirstDrivingDimension",1,0],[0,"SectionView",1,0],[0,"SketchChecking",1,0],[0,"SliceOption",1,0],[0,"SnapAngle",1,0],[0,"SolvingTolerance",1,0],[0,"TextSizeFixed",1,0],[0,"UpdateSketchOnly",1,0],[0,"UseSolvingTolerance",1,0]],[],[]];
SPLM.Preferences.SessionSketch = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.SessionSketch";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.SessionSketch.OriginType = Object.freeze({
    "InferFromPlaneSelection" : "InferFromPlaneSelection", "ProjectWorkPartOrigin" : "ProjectWorkPartOrigin"});

SPLM.Preferences.SessionSketch.BackgroundType = Object.freeze({
    "Inherit" : "Inherit", "Plain" : "Plain"});

SPLM.Preferences.SessionSketch.RigidSetConstraintType = Object.freeze({
    "PreventConflict" : "PreventConflict", "PreserveAll" : "PreserveAll"});

SPLM.Preferences.SessionSketch.GroupConstraintType = Object.freeze({
    "PreventConflict" : "PreventConflict", "PreserveAll" : "PreserveAll"});

SPLM.Preferences.SessionSketch.LineOutputType = Object.freeze({
    "Segment" : "Segment", "AddInfiniteLine" : "AddInfiniteLine", "InfiniteLine" : "InfiniteLine"});

export default SPLM;